/* PET · Favoritos (wishlist) — guarda en el navegador (localStorage).
   Funciona sin cuenta. Cualquier botón con [data-pet-wish="<handle>"] queda sincronizado.
   Para una lista persistente entre dispositivos hace falta cuenta de cliente + metafield/app. */
(function () {
  var KEY = 'pet_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function sync() {
    var list = read();
    document.querySelectorAll('[data-pet-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-pet-wish')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-pet-wish-count]').forEach(function (el) {
      el.textContent = list.length;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pet-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-pet-wish');
    if (!handle) return;
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.push(handle); }
    write(list);
    sync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  // Re-sincroniza tras navegación del editor de temas / secciones dinámicas.
  document.addEventListener('shopify:section:load', sync);

  // Expuesto para que el filtrado AJAX re-sincronice los corazones tras cada swap.
  window.PetWishlist = { sync: sync };
})();
